'use client';

import type { ReactNode } from 'react';
import Link from 'next/link';
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/navigation/dropdown-menu';

export type GroupedNavDropdownItem = {
  key?: string;
  label: string;
  href: string;
  id?: string;
  onClick?: () => void;
  /** When true, renders as a button that runs `onClick` instead of a navigating `Link`. */
  isContact?: boolean;
};

export type GroupedNavDropdownGroup = {
  key?: string;
  groupLabel?: string;
  items: GroupedNavDropdownItem[];
};

export function GroupedNavDropdownContent({
  groups,
  renderAfterGroup,
}: {
  groups: GroupedNavDropdownGroup[];
  renderAfterGroup?: (
    group: GroupedNavDropdownGroup,
    groupIndex: number
  ) => ReactNode;
}) {
  return (
    <>
      {groups.map((group, groupIdx) => (
        <div key={group.key ?? `${group.groupLabel ?? 'group'}-${groupIdx}`}>
          {groupIdx > 0 && <DropdownMenuSeparator />}
          {group.groupLabel && (
            <DropdownMenuLabel>
              {group.groupLabel}
            </DropdownMenuLabel>
          )}
          {group.items.map((item, itemIdx) => (
            <DropdownMenuItem
              key={item.key ?? item.href ?? `${item.label}-${itemIdx}`}
              asChild
            >
              {item.isContact ? (
                <button type="button" id={item.id} onClick={item.onClick}>
                  {item.label}
                </button>
              ) : (
                <Link href={item.href} id={item.id} onClick={item.onClick}>
                  {item.label}
                </Link>
              )}
            </DropdownMenuItem>
          ))}
          {renderAfterGroup ? renderAfterGroup(group, groupIdx) : null}
        </div>
      ))}
    </>
  );
}
